<!-- eslint-disable indent -->
<template>
  <div class="content">
    <div class="cwgl-home">
      <el-row :gutter="16" class="summary-row">
        <el-col :span="8">
          <el-card shadow="always" class="summary-card">
            <div class="summary-header">
              <div class="title">
                <img class="title-dot" :src="littleIcon" alt="" />
                借款
              </div>
              <img class="summary-icon" :src="loanIcon" alt="借款" />
            </div>
            <div class="metrics">
              <div class="metric">
                <div class="label">总借款金额</div>
                <div class="value">{{ formatNumber(summary.loan.total) }}</div>
              </div>
              <div class="metric">
                <div class="label">待还金额</div>
                <div class="link" @click="handleClick('loan.pending')">
                  {{ formatNumber(summary.loan.pending) }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="always" class="summary-card">
            <div class="summary-header">
              <div class="title">
                <img class="title-dot" :src="littleIcon" alt="" />
                差旅报销
              </div>
              <img class="summary-icon" :src="travelIcon" alt="差旅报销" />
            </div>
            <div class="metrics">
              <div class="metric">
                <div class="label">累计报销金额</div>
                <div class="value">{{ formatNumber(summary.travel.total) }}</div>
              </div>
              <div class="metric">
                <div class="label">待打款金额</div>
                <div class="link" @click="handleClick('travel.pending')">
                  {{ formatNumber(summary.travel.pending) }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="always" class="summary-card">
            <div class="summary-header">
              <div class="title">
                <img class="title-dot" :src="littleIcon" alt="" />
                费用报销
              </div>
              <img class="summary-icon" :src="expenseIcon" alt="费用报销" />
            </div>
            <div class="metrics">
              <div class="metric">
                <div class="label">累计报销金额</div>
                <div class="value">{{ formatNumber(summary.expense.total) }}</div>
              </div>
              <div class="metric">
                <div class="label">待打款金额</div>
                <div class="link" @click="handleClick('expense.pending')">
                  {{ formatNumber(summary.expense.pending) }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 列表区：我的待办 / 我的已办 -->
      <el-row :gutter="16">
        <el-col :span="12">
          <el-card shadow="never" class="list-card">
            <div slot="header" class="df aic jcb">
              <div class="title">
                <img class="title-dot" :src="littleIcon" alt="" />
                我的待办
              </div>
              <el-button type="text" size="small" @click="gotoMore('todo')">更多</el-button>
            </div>
            <el-table
              class="task-table"
              :data="todoList"
              v-loading="loadingTodo"
              size="small"
              border
              stripe
              :height="fixedTableHeight"
              :row-style="taskRowStyle"
            >
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column
                prop="taskName"
                label="任务名称"
                min-width="120"
                show-overflow-tooltip
              />
              <el-table-column
                prop="clientName"
                label="申请人/单位"
                min-width="120"
                show-overflow-tooltip
              />
              <el-table-column prop="createdate" label="申请时间" width="140" />
              <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="showTaskTodo(scope.row)">
                    操作
                  </el-button>
                  <el-button size="small" type="success" @click="showflowPressTodo(scope.row)">
                    进展
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="never" class="list-card">
            <div slot="header" class="df aic jcb">
              <div class="title">
                <img class="title-dot" :src="littleIcon" alt="" />
                我的已办
              </div>
              <el-button type="text" size="small" @click="gotoMore('done')">更多</el-button>
            </div>
            <el-table
              class="task-table"
              :data="doneList"
              v-loading="loadingDone"
              size="small"
              border
              stripe
              :height="fixedTableHeight"
              :row-style="taskRowStyle"
            >
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column
                prop="taskName"
                label="任务名称"
                min-width="120"
                show-overflow-tooltip
              />
              <el-table-column
                prop="clientName"
                label="申请人/单位"
                min-width="120"
                show-overflow-tooltip
              />
              <el-table-column prop="createdate" label="申请时间" width="140" />
              <!-- <el-table-column prop="endTime" label="处理时间" width="140" /> -->
              <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="showTask(scope.row)">
                    查看
                  </el-button>
                  <el-button size="small" type="success" @click="showflowPress(scope.row)">
                    进展
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>

      <!-- 进展（流程图） -->
      <el-dialog
        title="流程设计器"
        :visible="diagramDialogVisible"
        v-if="diagramDialogVisible"
        :fullscreen="true"
        :before-close="closeDiagram"
      >
        <diagram :tmplId="instanceId" @closeDiagram="closeDiagram" />
      </el-dialog>

      <!-- 我的待办：流程进展 -->
      <el-dialog
        title="流程进展"
        v-if="progressDialogVisible"
        :visible="progressDialogVisible"
        :before-close="closeProgressDialog"
      >
        <progressInfo
          :query="query"
          @closeDiagram="closeProgressDialog"
          v-if="progressDialogVisible"
        />
      </el-dialog>

      <!-- 差旅报销详情 -->
      <el-dialog
        title="差旅报销详情"
        :visible.sync="clbxDetailVisible"
        width="80%"
        :before-close="closeclbxDetail"
      >
        <clbxDetail
          ref="clbxApproveForm"
          :readonly="true"
          :instanceId="clbxInstanceId"
          :userType="userType"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeclbxDetail">关闭</el-button>
        </span>
      </el-dialog>

      <!-- 费用报销详情 -->
      <el-dialog
        title="费用报销详情"
        :visible.sync="fybxDetailVisible"
        width="80%"
        :before-close="closeFybxDetail"
      >
        <fybxDetail
          ref="fybxDetail"
          :readonly="true"
          :instanceId="fybxInstanceId"
          :userType="userType"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeFybxDetail">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import diagram from '@/views/flow/diagram/progress';
import { getList as getTaskedList } from '@/views/flow/history/instance/function';
import { getList as getTodoList } from '@/views/flow/task/function';
import clbxDetail from '@/fpComponents/clbxDeatil.vue';
import fybxDetail from '@/fpComponents/fybxDetail.vue';
import progressInfo from '@/views/flow/progressInfo/index.vue';

export default {
  name: 'CwglHome',
  components: { diagram, clbxDetail, fybxDetail, progressInfo },
  data() {
    return {
      summary: {
        loan: { total: 0, pending: 0 },
        travel: { total: 0, pending: 0 },
        expense: { total: 0, pending: 0 }
      },
      fixedTableHeight: 300, // 修改默认高度
      taskRowHeight: 44,
      loanIcon: require('@/assets/images/home/icon_jiekuan.svg'),
      travelIcon: require('@/assets/images/home/icon_cailvbaoxiao.svg'),
      expenseIcon: require('@/assets/images/home/icon_feiyongbaoxiao.svg'),
      littleIcon: require('@/assets/images/home/icon_little_biaoti.svg'),

      // 列表数据
      todoList: [],
      doneList: [],
      loadingTodo: false,
      loadingDone: false,

      // 进展/详情
      diagramDialogVisible: false,
      instanceId: 0,
      userType: '3',
      clbxDetailVisible: false,
      fybxDetailVisible: false,
      clbxInstanceId: '',
      fybxInstanceId: '',

      // 我的待办：进展
      progressDialogVisible: false,
      query: {
        instanceId: '',
        taskId: '',
        formKey: '',
        taskName: '',
        taskDefKey: ''
      }
    };
  },
  mounted() {
    this.fetchSummaryCounts();
    this.fetchTodoList();
    this.fetchDoneList();
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
    this.$nextTick(() => {
      this.checkPendingConfirmNotice();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    async checkPendingConfirmNotice() {
      console.log('checkPendingConfirmNotice');
      try {
        const roleRes = await this.$api.formPost('/api/major/htgl/getUserRoleType', {});
        if (!roleRes || !roleRes.retHead || roleRes.retHead.code !== '0000000') {
          return;
        }
        if (roleRes.retBody !== '2') {
          return;
        }

        const contractRes = await this.$api.formPost('/api/major/htgl/doGetList', {
          pageNum: 1,
          pageSize: 1,
          htZt: '1'
        });
        if (
          !contractRes ||
          !contractRes.retHead ||
          contractRes.retHead.code !== '0000000' ||
          !contractRes.retBody
        ) {
          return;
        }

        const pendingCount = Number(contractRes.retBody.total) || 0;
        if (pendingCount <= 0) {
          return;
        }
        this.$nextTick(() => {
          this.$notify({
            title: '待确认提醒',
            message: `当前有${pendingCount}份合同毛利待确认，请及时处理。`,
            type: 'warning',
            position: 'top-right',
            duration: 4500
          });
        });
      } catch (error) {
        console.warn('首页待确认通知检查失败:', error);
      }
    },
    calculateTableHeight() {
      // 视口高度自适应，使用flex布局后不需要再计算具体高度
      // 设置一个最小高度即可
      this.fixedTableHeight = 200;
    },
    taskRowStyle() {
      return { height: this.taskRowHeight + 'px' };
    },
    formatNumber(num) {
      if (num === null || typeof num === 'undefined') return '-';
      const n = Number(num);
      if (isNaN(n)) return '-';
      return n.toLocaleString('zh-CN');
    },
    handleClick(type) {
      this.$emit('summary-click', type);
    },
    fetchSummaryCounts() {
      const safeParse = (body, totalKey, pendingKey) => {
        if (!body) return { total: 0, pending: 0 };
        let totalRaw = 0;
        if (body[totalKey] != null) {
          totalRaw = body[totalKey];
        } else if (body.total != null) {
          totalRaw = body.total;
        } else if (body.totalAmount != null) {
          totalRaw = body.totalAmount;
        }

        let pendingRaw = 0;
        if (body[pendingKey] != null) {
          pendingRaw = body[pendingKey];
        } else if (body.pending != null) {
          pendingRaw = body.pending;
        } else if (body.pendingAmount != null) {
          pendingRaw = body.pendingAmount;
        }
        const total = Number(totalRaw);
        const pending = Number(pendingRaw);
        return { total: isNaN(total) ? 0 : total, pending: isNaN(pending) ? 0 : pending };
      };
      const jkReq = this.$api.formPost('/api/cwgl/jk/getCount', {});
      const clbxReq = this.$api.formPost('/api/cwgl/clbx/getCount', {});
      const fybxReq = this.$api.formPost('/api/cwgl/fybx/getCount', {});
      Promise.allSettled([jkReq, clbxReq, fybxReq]).then(([jk, clbx, fybx]) => {
        if (
          jk.status === 'fulfilled' &&
          jk.value &&
          jk.value.retHead &&
          jk.value.retHead.code === '0000000'
        ) {
          const { total, pending } = safeParse(jk.value.retBody, 'jkTotal', 'dhje');
          this.summary.loan.total = total;
          this.summary.loan.pending = pending;
        }
        if (
          clbx.status === 'fulfilled' &&
          clbx.value &&
          clbx.value.retHead &&
          clbx.value.retHead.code === '0000000'
        ) {
          const { total, pending } = safeParse(clbx.value.retBody, 'ljje', 'ddkje');
          this.summary.travel.total = total;
          this.summary.travel.pending = pending;
        }
        if (
          fybx.status === 'fulfilled' &&
          fybx.value &&
          fybx.value.retHead &&
          fybx.value.retHead.code === '0000000'
        ) {
          const { total, pending } = safeParse(fybx.value.retBody, 'ljje', 'ddkje');
          this.summary.expense.total = total;
          this.summary.expense.pending = pending;
        }
      });
    },
    // 数据获取
    fetchTodoList() {
      this.loadingTodo = true;
      const params = { pageNum: 1, pageSize: 10 };
      getTodoList(params)
        .then((res) => {
          if (res && res.retHead && res.retHead.code === '0000000') {
            const list = (res.retBody && res.retBody.list) || [];
            this.todoList = list.slice(0, 10);
          }
        })
        .finally(() => (this.loadingTodo = false));
    },
    fetchDoneList() {
      this.loadingDone = true;
      const params = { pageNum: 1, pageSize: 10 };
      getTaskedList(params)
        .then((res) => {
          if (res && res.retHead && res.retHead.code === '0000000') {
            const list = (res.retBody && res.retBody.list) || [];
            this.doneList = list.slice(0, 10);
          }
        })
        .finally(() => (this.loadingDone = false));
    },
    gotoMore(type) {
      if (type === 'todo') {
        this.$router.push({ path: '/flow/task' });
      } else if (type === 'done') {
        this.$router.push({ path: '/flow/his/instance' });
      }
    },
    // 进展（我的已办保留原逻辑）
    showflowPress(row) {
      this.diagramDialogVisible = true;
      this.instanceId = row.instanceId;
    },
    closeDiagram() {
      this.diagramDialogVisible = false;
    },
    // 查看
    showTask(row) {
      if (row.formkey && row.formkey.includes('clbx')) {
        this.loadclbxDetailData(row.instanceId);
      } else if (row.formkey && row.formkey.includes('fybx')) {
        this.loadFybxDetailData(row.instanceId);
      } else {
        this.$router.push({
          path: row.formkey,
          query: {
            taskId: row.taskId,
            instanceId: row.instanceId,
            name: row.formkey,
            nodeId: row.nodeid,
            taskName: row.taskName,
            taskDefKey: row.taskDefinitionKey,
            editStatus: row.editStatus ? row.editStatus : 2,
            isTasked: row.endTime ? 1 : 0,
            businesskey: row.businesskey
          }
        });
      }
    },
    // 我的待办：操作
    showTaskTodo(row) {
      this.$router.push({
        path: row.formkey,
        query: {
          taskId: row.taskId,
          instanceId: row.instanceId,
          name: row.formkey,
          nodeId: row.nodeid,
          taskName: row.taskName,
          taskDefKey: row.taskDefinitionKey,
          businesskey: row.businesskey,
          editStatus: 1
        }
      });
    },
    // 我的待办：进展
    showflowPressTodo(row) {
      this.query.instanceId = row.instanceId;
      this.progressDialogVisible = true;
    },
    closeProgressDialog() {
      this.progressDialogVisible = false;
    },
    loadclbxDetailData(instanceId) {
      this.$api
        .formPost('/api/cwgl/clbx/getClbxUserType')
        .then((typeRes) => {
          if (typeRes && typeRes.retHead && typeRes.retHead.code === '0000000') {
            this.userType = typeRes.retBody;
          }
        })
        .finally(() => {
          this.clbxInstanceId = instanceId;
          this.clbxDetailVisible = true;
        });
    },
    loadFybxDetailData(instanceId) {
      this.$api
        .formPost('/api/cwgl/fybx/getFybxUserType')
        .then((typeRes) => {
          if (typeRes && typeRes.retHead && typeRes.retHead.code === '0000000') {
            this.userType = typeRes.retBody;
          }
        })
        .finally(() => {
          this.fybxInstanceId = instanceId;
          this.fybxDetailVisible = true;
        });
    },
    closeclbxDetail() {
      this.clbxDetailVisible = false;
      this.clbxInstanceId = '';
    },
    closeFybxDetail() {
      this.fybxDetailVisible = false;
      this.fybxInstanceId = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  position: relative;
  width: 100%;
  zoom: 1.2;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cwgl-home {
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.summary-row {
  margin-bottom: 10px;
  flex-shrink: 0;
}
.summary-card {
  position: relative;
  border-radius: 10px;
}
.summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #2f4155;
}
.title-dot {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.summary-icon {
  width: 28px;
  height: 28px;
}
.metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 12px;
  margin-top: 12px;
}
.metric {
  background: #f8fbff;
  border-radius: 8px;
  padding: 10px 12px;
}
.label {
  font-size: 14px;
  color: #8a97a8;
}
.value {
  margin-top: 6px;
  font-size: 24px;
  font-weight: 700;
  color: #2f4155;
}
.link {
  margin-top: 6px;
  font-size: 20px;
  font-weight: 700;
  color: #1b78f2;
  cursor: pointer;
}
.list-card {
  margin-top: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep .task-table .el-table__row .cell {
  padding-top: 0;
  padding-bottom: 0;
  line-height: 40px;
}

::v-deep .el-card__body {
  height: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep .el-table {
  flex: 1;
}
/* 添加新样式 */
.el-row:nth-child(2) {
  flex: 1;
  overflow: hidden;
  margin-bottom: 0;
  display: flex;
}

.el-row:nth-child(2) .el-col {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
